import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '2rem',
    marginBottom: '-2rem',
  },

  buttonBox: {
    display: 'flex',
    gap: '1rem',
    width: '100%',
  },

  button: {
    minWidth: '223px',
    padding: '0.15rem 3rem',
    height: '2.5rem',
  },

  centerBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '1rem',
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '480px',
  },

  paper: {
    width: '700px',
    height: '100%',

    '& img': {
      width: '130px',
      height: '88px',
      objectFit: 'cover',
    },
  },

  paperContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.2rem',
  },

  paperTitle: {
    fontSize: '1.5rem',
    fontWeight: 'semi-bold',
  },
}))

export { useStyles }
